import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://api-etampon.xegit.com";

export const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "https://api-etampon.xegit.com",
  },
});

// Intercepteur pour les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Services pour les parents
export const parentService = {
  getParents: () => api.get("/parents"),
  getMyParentData: () => api.get("/parents/me"),
  getParent: (id) => api.get(`/parents/${id}`),
  getParentQR: (id) => api.get(`/parents/${id}/qr`),
  getCarteTampons: (id) => api.get(`/parents/${id}/carte-tampons`),
  getHistorique: (id) => api.get(`/parents/${id}/historique`),
  createParent: (data) => api.post("/parents", data),
  createCompleteParent: (data) => api.post("/parents/create-complete", data),
  deleteParent: (id) => api.delete(`/parents/${id}`),
  updateNiveau: (id, niveau) =>
    api.put(`/parents/${id}/niveau`, { nouveau_niveau: niveau }),
};

// Services pour les tampons
export const tamponService = {
  getTampons: () => api.get("/tampons"),
  getTampon: (id) => api.get(`/tampons/${id}`),
  scanQR: (data) => api.post("/tampons/scan-qr", data),
  validateManual: (data) => api.post("/tampons/validate-manual", data),
  createTampon: (data) => api.post("/tampons", data),
  deleteTampon: (id) => api.delete(`/tampons/${id}`),
};

// Services pour la validation QR
export const validationService = {
  validateQR: (qrCode) => api.get(`/validate/qr/${qrCode}`),
  validateCodeUnique: (codeUnique) => api.get(`/validate/code/${codeUnique}`),
  confirmValidation: (qrCode, activiteId, commentaire) =>
    api.post("/validate/confirm", {
      qr_code: qrCode,
      activite_id: activiteId,
      commentaire: commentaire,
    }),
  getValidationSuccess: (tamponId) => api.get(`/validate/success/${tamponId}`),
};

// Services pour les activités
export const activiteService = {
  getActivites: (params = {}) => api.get("/activites", { params }),
  getActivite: (id) => api.get(`/activites/${id}`),
  createActivite: (data) => api.post("/activites", data),
  updateActivite: (id, data) => api.put(`/activites/${id}`, data),
  deleteActivite: (id) => api.delete(`/activites/${id}`),
  getParticipants: (id) => api.get(`/activites/${id}/participants`),
  toggleStatus: (id) => api.post(`/activites/${id}/toggle-status`),
};

// Services pour les récompenses
export const recompenseService = {
  getRecompenses: (params = {}) => api.get("/recompenses", { params }),
  getRecompense: (id) => api.get(`/recompenses/${id}`),
  createRecompense: (data) => api.post("/recompenses", data),
  updateRecompense: (id, data) => api.put(`/recompenses/${id}`, data),
  deleteRecompense: (id) => api.delete(`/recompenses/${id}`),
  getParentRecompenses: (parentId) =>
    api.get(`/recompenses/parent/${parentId}`),
  attribuerRecompense: (recompenseId, parentId) =>
    api.post(`/recompenses/${recompenseId}/attribuer/${parentId}`),
  marquerTelechargee: (id) => api.post(`/recompenses/${id}/telecharger`),
  getStats: () => api.get("/recompenses/stats/globales"),
};

// Services pour les statistiques
export const statsService = {
  getGlobales: () => api.get("/stats/globales"),
  getTopParents: (limit = 10) =>
    api.get("/stats/parents/top", { params: { limit } }),
  getActivitesPopulaires: (limit = 10) =>
    api.get("/stats/activites/populaires", { params: { limit } }),
  getParticipationMensuelle: (mois, annee) =>
    api.get("/stats/participation/mensuelle", { params: { mois, annee } }),
  getParticipationParClasse: () => api.get("/stats/participation/par-classe"),
  getStatsRecompenses: () => api.get("/stats/recompenses/attribution"),
  exportCSV: () => api.get("/stats/export/csv"),
};

// Services d'authentification
export const authService = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  getMe: () => api.get("/auth/me"),
  register: (data) => api.post("/auth/register", data),
  changePassword: (currentPassword, newPassword) =>
    api.post("/auth/change-password", {
      current_password: currentPassword,
      new_password: newPassword,
    }),
  forgotPassword: (email) => api.post("/auth/forgot-password", { email }),
  resetPassword: (token, newPassword) =>
    api.post("/auth/reset-password", {
      token,
      new_password: newPassword,
    }),
  logout: () => api.post("/auth/logout"),
};
